import React, { type ReactElement } from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import SubordinatesTabs from '../../components/Subordinates/SubordinatesTabs/SubordinatesTabs';
import SubordinatesTable from '../../components/Subordinates/SubordinateTable/SubordinatesTable';
import InvitationsTable from '../../components/Subordinates/InvitationTable/InvitationsTable';
import { INVITATIONS_ROUTE, SUBORDINATES_ROUTE } from '../../utils/routes';

export default function Subordinates(): ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [
    {
      label: 'Subordinates',
      path: SUBORDINATES_ROUTE,
      children: <SubordinatesTable />,
    },
    {
      label: 'Invitations',
      path: INVITATIONS_ROUTE,
      children: <InvitationsTable />,
    },
  ];

  const activeTab = tabs.findIndex((tab) => location.pathname === tab.path);

  const handleTabChange = (index: number) => {
    navigate(tabs[index].path); // Update URL to the selected tab's path
  };

  return (
    <Box width="100%" overflow="auto" height="fit-content" minHeight="100vh">
      <SubordinatesTabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} />
    </Box>
  );
}
